var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame1000005914(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 8,
    fill: "url(#paint0_linear_580_352)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.755 17.7642H19.2306C16.83 17.7642 14.875 19.7192 14.875 22.1198V26.4898H55.1106V22.1198C55.1106 19.7192 53.1556 17.7642 50.755 17.7642ZM21.0505 23.369C20.3648 23.369 19.8085 22.8127 19.8085 22.127C19.8085 21.4413 20.3648 20.885 21.0505 20.885C21.7362 20.885 22.2925 21.4413 22.2925 22.127C22.2925 22.8127 21.7362 23.369 21.0505 23.369ZM25.4277 23.369C24.742 23.369 24.1857 22.8127 24.1857 22.127C24.1857 21.4413 24.742 20.885 25.4277 20.885C26.1134 20.885 26.6697 21.4413 26.6697 22.127C26.6697 22.8127 26.1134 23.369 25.4277 23.369ZM29.8049 23.369C29.1192 23.369 28.5629 22.8127 28.5629 22.127C28.5629 21.4413 29.1192 20.885 29.8049 20.885C30.4906 20.885 31.0469 21.4413 31.0469 22.127C31.0469 22.8127 30.4906 23.369 29.8049 23.369Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8092 40.3472C53.6736 39.3266 51.9773 38.6797 50.0655 38.6797C47.9667 38.6797 46.1123 39.4559 44.9911 40.6491C43.8842 39.4559 42.0298 38.6797 39.9311 38.6797C38.0192 38.6797 36.3086 39.3266 35.1873 40.3472C34.9717 40.5341 34.8711 40.8072 34.8711 41.0803V50.2516C34.8711 51.0278 35.7048 51.4734 36.3805 51.1141C37.3867 50.5822 38.6086 50.2659 39.9311 50.2659C42.0298 50.2659 43.8842 51.0422 44.9911 52.2353C46.1123 51.0422 47.9667 50.2659 50.0655 50.2659C51.388 50.2659 52.6098 50.5822 53.6161 51.1141C54.2917 51.4734 55.1111 51.0278 55.1111 50.2516V41.0803C55.1111 40.8072 55.0105 40.5341 54.8092 40.3472Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7144 50.2516V41.0804C32.7144 40.1647 33.0996 39.3036 33.7709 38.72C35.2918 37.3357 37.5487 36.5235 39.9306 36.5235C41.8094 36.5235 43.5704 37.0094 44.9949 37.8934C46.4267 37.0094 48.1905 36.5235 50.0636 36.5235C51.9064 36.5235 53.6717 37.0295 55.1092 37.915V28.646H14.875V47.8654C14.875 50.2804 16.83 52.2354 19.245 52.2354H33.4446C32.9947 51.692 32.7144 51.0077 32.7144 50.2516Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_580_352",
    x1: 1.5,
    y1: 3,
    x2: 70,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#981A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1000005914);
export default __webpack_public_path__ + "static/media/Frame1000005914.ebb8f68e021ae2da7b204f29205683ee.svg";
export { ForwardRef as ReactComponent };